import { environment } from "./environment.base";
export { environment };

environment.name = 'dyno';
environment.parentUrl =  'https://dyno.strayos.com';
environment.baseUrl = 'https://dynodashboards.strayos.com';
environment.apiUrl = 'https://dynodb.strayos.com';